import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              黑料网吃瓜
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              汇聚全网最新最劲爆的吃瓜资讯，实时更新热点事件，让你第一时间吃到最新鲜的瓜，不错过任何热门话题与大料。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快捷链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                首页
              </Link>
              <Link to="/category/zuixin" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                最新瓜报
              </Link>
              <Link to="/category/mingxing" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                明星爆料
              </Link>
              <Link to="/category/bagua" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                娱乐八卦
              </Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <p>邮箱：tips@heiliao.com</p>
              <p>商务合作：biz@heiliao.com</p>
              <p>工作时间：周一至周五 9:00-18:00</p>
              <div className="flex items-center gap-3 mt-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-foreground-600"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-foreground-600"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-foreground-600"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料网吃瓜 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" rel="nofollow" className="hover:text-primary-500 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" rel="nofollow" className="hover:text-primary-500 transition-colors cursor-pointer">用户协议</a>
            <a href="#" rel="nofollow" className="hover:text-primary-500 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}